import { useEffect, useState } from "react";
import { Link, useLoaderData, useParams } from "react-router-dom";
import * as API from "../services/analiticas";
import { getArchivo } from "../services/archivos";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAnaliticasByID(params.analiticasId);
}

export function AnaliticasPacienteItem(props) {
  const analiticas = useLoaderData();
  const errorLoadMessage = analiticas.message;

  const [warningMessages, setWarningMessages] = useState([]);
  const [warningSecondMessages, setWarningSecondMessages] = useState([]);
  const [warningGeneralMessages, setWarningGeneralMessages] = useState([]);

  const [analiticaIsSecond, setAnaliticaIsSecond] = useState(
    analiticas.meta?.analiticaIsSecond
  );

  const isNotJson = analiticas.meta?.isNotJson;

  const analiFecha = analiticas.meta?.metaFecha;

  const analiFechaAnali = analiticas.meta?.analiFechaAnali;
  const analiName = analiticas.meta?.analiName;
  const analiSurname = analiticas.meta?.analiSurname;
  const analiBed = analiticas.meta?.analiBed;
  const analiNhc = analiticas.meta?.analiNhc;
  const analiDni = analiticas.meta?.analiDni;
  const analiSex = analiticas.meta?.analiSex;
  const analiOrigen = analiticas.meta?.analiOrigen;
  const analiDoctor = analiticas.meta?.analiDoctor;
  const analiObs = analiticas.meta?.analiObs;

  const analiJson = analiticas.meta?.analiticaJson;

  const analiFileLink = analiticas.meta?.analiFileLink;

  const [analiticaCompleta, setAnaliticaCompleta] = useState(null);

  useEffect(() => {
    setWarningMessages([]);
    setWarningSecondMessages([]);
    setWarningGeneralMessages([]);
    setAnaliticaIsSecond(analiticas.meta?.analiticaIsSecond);
    if (!isNotJson) {
      try {
        const parsedJson = JSON.parse(analiticas.meta?.analiticaJson);
        setAnaliticaCompleta(parsedJson);
      } catch (error) {
        const errorMessage = "Error al analizar el JSON: " + error.message;
        console.log(errorMessage);
        setWarningGeneralMessages((prevMessages) => [
          ...prevMessages,
          errorMessage,
        ]);
      }
    } else {
      setAnaliticaCompleta(null);
    }
  }, [analiticas]);

  // Función para calcular los limites y resultados de las analiticas
  const createResultProperties = (result, low, high) => {
    // Convertir los strings que vienen del meta a numbers
    result = parseFloat(result);
    low = parseFloat(low);
    high = parseFloat(high);
    const color =
      result >= low && result <= high
        ? "anali-result-good"
        : "anali-result-bad";
    const markIn = Math.min(
      Math.max(((result - low) / (high - low)) * 100, 0),
      100
    ).toFixed(0);
    const markOut =
      result < low
        ? "anali-result-low"
        : result > high
        ? "anali-result-high"
        : "";
    return { color, markIn, markOut };
  };

  // Hematíes
  const analiHematiesResult = analiticas.meta?.analiHematiesResult;
  const analiHematiesLow = (analiticas.meta?.analiHematiesLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_12?.limits2.L.toFixed(2) : analiticas.meta?.analiHematiesLow;
  const analiHematiesHigh = (analiticas.meta?.analiHematiesHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_12?.limits2.H.toFixed(2) : analiticas.meta?.analiHematiesHigh;
  const {
    color: analiHematiesColor,
    markIn: analiHematiesMarkIn,
    markOut: analiHematiesMarkOut,
  } = createResultProperties(
    analiHematiesResult,
    analiHematiesLow,
    analiHematiesHigh
  );
  useEffect(() => {
    if (
      analiHematiesResult === undefined ||
      analiHematiesResult === null ||
      analiHematiesResult === 0 ||
      analiHematiesResult === ""
    ) {
      let errorMessage = "No existen datos de Hematies";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiHematiesResult]);

  // Hemoglobina
  const analiHemoglobResult = analiticas.meta?.analiHemoglobResult;
  const analiHemoglobLow = (analiticas.meta?.analiHemoglobLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_13?.limits2.L.toFixed(2) : analiticas.meta?.analiHemoglobLow;
  const analiHemoglobHigh = (analiticas.meta?.analiHemoglobHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_13?.limits2.H.toFixed(2) : analiticas.meta?.analiHemoglobHigh;

  const {
    color: analiHemoglobColor,
    markIn: analiHemoglobMarkIn,
    markOut: analiHemoglobMarkOut,
  } = createResultProperties(
    analiHemoglobResult,
    analiHemoglobLow,
    analiHemoglobHigh
  );
  useEffect(() => {
    if (
      analiHemoglobResult === undefined ||
      analiHemoglobResult === null ||
      analiHemoglobResult === 0 ||
      analiHemoglobResult === ""
    ) {
      let errorMessage = "No existen datos de Hemoglobina";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiHemoglobResult]);

  // Hematocrito
  const analiHematcrResult = analiticas.meta?.analiHematcrResult;
  const analiHematcrLow = (analiticas.meta?.analiHematcrLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_14?.limits2.L.toFixed(2) : analiticas.meta?.analiHematcrLow;
  const analiHematcrHigh = (analiticas.meta?.analiHematcrHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_14?.limits2.H.toFixed(2) : analiticas.meta?.analiHematcrHigh;

  const {
    color: analiHematcrColor,
    markIn: analiHematcrMarkIn,
    markOut: analiHematcrMarkOut,
  } = createResultProperties(
    analiHematcrResult,
    analiHematcrLow,
    analiHematcrHigh
  );
  useEffect(() => {
    if (
      analiHematcrResult === undefined ||
      analiHematcrResult === null ||
      analiHematcrResult === 0 ||
      analiHematcrResult === ""
    ) {
      let errorMessage = "No existen datos de Hematocrito";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiHematcrResult]);

  // VCM
  const analiVcmResult = analiticas.meta?.analiVcmResult;
  const analiVcmLow = (analiticas.meta?.analiVcmLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_15?.limits2.L.toFixed(2) : analiticas.meta?.analiVcmLow;
  const analiVcmHigh = (analiticas.meta?.analiVcmHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_15?.limits2.H.toFixed(2) : analiticas.meta?.analiVcmHigh;

  const {
    color: analiVcmColor,
    markIn: analiVcmMarkIn,
    markOut: analiVcmMarkOut,
  } = createResultProperties(analiVcmResult, analiVcmLow, analiVcmHigh);
  useEffect(() => {
    if (
      analiVcmResult === undefined ||
      analiVcmResult === null ||
      analiVcmResult === 0 ||
      analiVcmResult === ""
    ) {
      let errorMessage = "No existen datos de VCM";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiVcmResult]);

  // HCM
  const analiHcmResult = analiticas.meta?.analiHcmResult;
  const analiHcmLow = (analiticas.meta?.analiHcmLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_16?.limits2.L.toFixed(2) : analiticas.meta?.analiHcmLow;
  const analiHcmHigh = (analiticas.meta?.analiHcmHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_16?.limits2.H.toFixed(2) : analiticas.meta?.analiHcmHigh;

  const {
    color: analiHcmColor,
    markIn: analiHcmMarkIn,
    markOut: analiHcmMarkOut,
  } = createResultProperties(analiHcmResult, analiHcmLow, analiHcmHigh);
  useEffect(() => {
    if (
      analiHcmResult === undefined ||
      analiHcmResult === null ||
      analiHcmResult === 0 ||
      analiHcmResult === ""
    ) {
      let errorMessage = "No existen datos de HCM";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiHcmResult]);

  // CHCM
  const analiChcmResult = analiticas.meta?.analiChcmResult;
  const analiChcmLow = (analiticas.meta?.analiChcmLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_17?.limits2.L.toFixed(2) : analiticas.meta?.analiChcmLow;
  const analiChcmHigh = (analiticas.meta?.analiChcmHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_17?.limits2.H.toFixed(2) : analiticas.meta?.analiChcmHigh;

  const {
    color: analiChcmColor,
    markIn: analiChcmMarkIn,
    markOut: analiChcmMarkOut,
  } = createResultProperties(analiChcmResult, analiChcmLow, analiChcmHigh);
  useEffect(() => {
    if (
      analiChcmResult === undefined ||
      analiChcmResult === null ||
      analiChcmResult === 0 ||
      analiChcmResult === ""
    ) {
      let errorMessage = "No existen datos de CHCM";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiChcmResult]);

  // IDH
  const analiIdhResult = analiticas.meta?.analiIdhResult;
  const analiIdhLow = (analiticas.meta?.analiIdhLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_20?.limits2.L.toFixed(2) : analiticas.meta?.analiIdhLow;
  const analiIdhHigh = (analiticas.meta?.analiIdhHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_20?.limits2.H.toFixed(2) : analiticas.meta?.analiIdhHigh;

  const {
    color: analiIdhColor,
    markIn: analiIdhMarkIn,
    markOut: analiIdhMarkOut,
  } = createResultProperties(analiIdhResult, analiIdhLow, analiIdhHigh);
  useEffect(() => {
    if (
      analiIdhResult === undefined ||
      analiIdhResult === null ||
      analiIdhResult === 0 ||
      analiIdhResult === ""
    ) {
      let errorMessage = "No existen datos de IDH";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiIdhResult]);

  // Leucocitos
  const analiLeucoResult = analiticas.meta?.analiLeucoResult;
  const analiLeucoLow = (analiticas.meta?.analiLeucoLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_18?.limits2.L.toFixed(2) : analiticas.meta?.analiLeucoLow;
  const analiLeucoHigh = (analiticas.meta?.analiLeucoHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_18?.limits2.H.toFixed(2) : analiticas.meta?.analiLeucoHigh;

  const {
    color: analiLeucoColor,
    markIn: analiLeucoMarkIn,
    markOut: analiLeucoMarkOut,
  } = createResultProperties(analiLeucoResult, analiLeucoLow, analiLeucoHigh);
  useEffect(() => {
    if (
      analiLeucoResult === undefined ||
      analiLeucoResult === null ||
      analiLeucoResult === 0 ||
      analiLeucoResult === ""
    ) {
      let errorMessage = "No existen datos de Leucocitos";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiLeucoResult]);

  // Neutrófilos segmentados
  const analiNeutrResult = analiticas.meta?.analiNeutrResult;
  const analiNeutrLow = (analiticas.meta?.analiNeutrLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_38?.limits2.L.toFixed(2) : analiticas.meta?.analiNeutrLow;
  const analiNeutrHigh = (analiticas.meta?.analiNeutrHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_38?.limits2.H.toFixed(2) : analiticas.meta?.analiNeutrHigh;

  const {
    color: analiNeutrColor,
    markIn: analiNeutrMarkIn,
    markOut: analiNeutrMarkOut,
  } = createResultProperties(analiNeutrResult, analiNeutrLow, analiNeutrHigh);
  useEffect(() => {
    if (
      analiNeutrResult === undefined ||
      analiNeutrResult === null ||
      analiNeutrResult === 0 ||
      analiNeutrResult === ""
    ) {
      let errorMessage = "No existen datos de Neutrófilos segmentados";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiNeutrResult]);

  // Linfocitos
  const analiLinfoResult = analiticas.meta?.analiLinfoResult;
  const analiLinfoLow = (analiticas.meta?.analiLinfoLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_40?.limits2.L.toFixed(2) : analiticas.meta?.analiLinfoLow;
  const analiLinfoHigh = (analiticas.meta?.analiLinfoHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_40?.limits2.H.toFixed(2) : analiticas.meta?.analiLinfoHigh;

  const {
    color: analiLinfoColor,
    markIn: analiLinfoMarkIn,
    markOut: analiLinfoMarkOut,
  } = createResultProperties(analiLinfoResult, analiLinfoLow, analiLinfoHigh);
  useEffect(() => {
    if (
      analiLinfoResult === undefined ||
      analiLinfoResult === null ||
      analiLinfoResult === 0 ||
      analiLinfoResult === ""
    ) {
      let errorMessage = "No existen datos de Linfocitos";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiLinfoResult]);

  // Monocitos
  const analiMonocResult = analiticas.meta?.analiMonocResult;
  const analiMonocLow = (analiticas.meta?.analiMonocLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_41?.limits2.L.toFixed(2) : analiticas.meta?.analiMonocLow;
  const analiMonocHigh = (analiticas.meta?.analiMonocHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_41?.limits2.H.toFixed(2) : analiticas.meta?.analiMonocHigh;

  const {
    color: analiMonocColor,
    markIn: analiMonocMarkIn,
    markOut: analiMonocMarkOut,
  } = createResultProperties(analiMonocResult, analiMonocLow, analiMonocHigh);
  useEffect(() => {
    if (
      analiMonocResult === undefined ||
      analiMonocResult === null ||
      analiMonocResult === 0 ||
      analiMonocResult === ""
    ) {
      let errorMessage = "No existen datos de Monocitos";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiMonocResult]);

  // Eosinófilos
  const analiEosinResult = analiticas.meta?.analiEosinResult;
  const analiEosinLow = (analiticas.meta?.analiEosinLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_31?.limits2.L.toFixed(2) : analiticas.meta?.analiEosinLow;
  const analiEosinHigh = (analiticas.meta?.analiEosinHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_31?.limits2.H.toFixed(2) : analiticas.meta?.analiEosinHigh;

  const {
    color: analiEosinColor,
    markIn: analiEosinMarkIn,
    markOut: analiEosinMarkOut,
  } = createResultProperties(analiEosinResult, analiEosinLow, analiEosinHigh);
  useEffect(() => {
    if (
      analiEosinResult === undefined ||
      analiEosinResult === null ||
      analiEosinResult === 0 ||
      analiEosinResult === ""
    ) {
      let errorMessage = "No existen datos de Eosinófilos";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiEosinResult]);

  // Basófilos
  const analiBasofResult = analiticas.meta?.analiBasofResult;
  const analiBasofLow = (analiticas.meta?.analiBasofLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_33?.limits2.L.toFixed(2) : analiticas.meta?.analiBasofLow;
  const analiBasofHigh = (analiticas.meta?.analiBasofHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_33?.limits2.H.toFixed(2) : analiticas.meta?.analiBasofHigh;

  const {
    color: analiBasofColor,
    markIn: analiBasofMarkIn,
    markOut: analiBasofMarkOut,
  } = createResultProperties(analiBasofResult, analiBasofLow, analiBasofHigh);
  useEffect(() => {
    if (
      analiBasofResult === undefined ||
      analiBasofResult === null ||
      analiBasofResult === 0 ||
      analiBasofResult === ""
    ) {
      let errorMessage = "No existen datos de Basófilos";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiBasofResult]);

  // Plaquetas
  const analiPlaqResult = analiticas.meta?.analiPlaqResult;
  const analiPlaqLow = (analiticas.meta?.analiPlaqLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_19?.limits2.L.toFixed(2) : analiticas.meta?.analiPlaqLow;
  const analiPlaqHigh = (analiticas.meta?.analiPlaqHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_19?.limits2.H.toFixed(2) : analiticas.meta?.analiPlaqHigh;

  const {
    color: analiPlaqColor,
    markIn: analiPlaqMarkIn,
    markOut: analiPlaqMarkOut,
  } = createResultProperties(analiPlaqResult, analiPlaqLow, analiPlaqHigh);
  useEffect(() => {
    if (
      analiPlaqResult === undefined ||
      analiPlaqResult === null ||
      analiPlaqResult === 0 ||
      analiPlaqResult === ""
    ) {
      let errorMessage = "No existen datos de Plaquetas";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiPlaqResult]);

  // PCT
  const analiPctResult = analiticas.meta?.analiPctResult;
  const analiPctLow = (analiticas.meta?.analiPctLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_22?.limits2.L.toFixed(2) : analiticas.meta?.analiPctLow;
  const analiPctHigh = (analiticas.meta?.analiPctHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_22?.limits2.H.toFixed(2) : analiticas.meta?.analiPctHigh;

  const {
    color: analiPctColor,
    markIn: analiPctMarkIn,
    markOut: analiPctMarkOut,
  } = createResultProperties(analiPctResult, analiPctLow, analiPctHigh);
  useEffect(() => {
    if (
      analiPctResult === undefined ||
      analiPctResult === null ||
      analiPctResult === 0 ||
      analiPctResult === ""
    ) {
      let errorMessage = "No existen datos de PCT";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiPctResult]);

  // VPM
  const analiVpmResult = analiticas.meta?.analiVpmResult;
  const analiVpmLow = (analiticas.meta?.analiVpmLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_30?.limits2.L.toFixed(2) : analiticas.meta?.analiVpmLow;
  const analiVpmHigh = (analiticas.meta?.analiVpmHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_30?.limits2.H.toFixed(2) : analiticas.meta?.analiVpmHigh;

  const {
    color: analiVpmColor,
    markIn: analiVpmMarkIn,
    markOut: analiVpmMarkOut,
  } = createResultProperties(analiVpmResult, analiVpmLow, analiVpmHigh);
  useEffect(() => {
    if (
      analiVpmResult === undefined ||
      analiVpmResult === null ||
      analiVpmResult === 0 ||
      analiVpmResult === ""
    ) {
      let errorMessage = "No existen datos de VPM";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiVpmResult]);

  // IDP
  const analiIdpResult = analiticas.meta?.analiIdpResult;
  const analiIdpLow = (analiticas.meta?.analiIdpLow === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_23?.limits2.L.toFixed(2) : analiticas.meta?.analiIdpLow;
  const analiIdpHigh = (analiticas.meta?.analiIdpHigh === "") ? analiticaCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_23?.limits2.H.toFixed(2) : analiticas.meta?.analiIdpHigh;

  const {
    color: analiIdpColor,
    markIn: analiIdpMarkIn,
    markOut: analiIdpMarkOut,
  } = createResultProperties(analiIdpResult, analiIdpLow, analiIdpHigh);
  useEffect(() => {
    if (
      analiIdpResult === undefined ||
      analiIdpResult === null ||
      analiIdpResult === 0 ||
      analiIdpResult === ""
    ) {
      let errorMessage = "No existen datos de IDP";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiIdpResult]);

  // Tiempo de Protrombina (seg)
  const analiTieProtResult = analiticas.meta?.analiTieProtResult;
  const analiTieProtLow = (analiticas.meta?.analiTieProtLow === "") ? analiticaCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_176?.limits2.L.toFixed(2) : analiticas.meta?.analiTieProtLow;
  const analiTieProtHigh = (analiticas.meta?.analiTieProtHigh === "") ? analiticaCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_176?.limits2.H.toFixed(2) : analiticas.meta?.analiTieProtHigh;

  const {
    color: analiTieProtColor,
    markIn: analiTieProtMarkIn,
    markOut: analiTieProtMarkOut,
  } = createResultProperties(
    analiTieProtResult,
    analiTieProtLow,
    analiTieProtHigh
  );
  useEffect(() => {
    if (
      analiTieProtResult === undefined ||
      analiTieProtResult === null ||
      analiTieProtResult === 0 ||
      analiTieProtResult === ""
    ) {
      let errorMessage = "No existen datos de Tiempo de Protrombina";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiTieProtResult]);

  // Actividad de Protrombina (%)
  const analiActProtResult = analiticas.meta?.analiActProtResult;
  const analiActProtLow = (analiticas.meta?.analiActProtLow === "") ? analiticaCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_177?.limits2.L.toFixed(2) : analiticas.meta?.analiActProtLow;
  const analiActProtHigh = (analiticas.meta?.analiActProtHigh === "") ? analiticaCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_177?.limits2.H.toFixed(2) : analiticas.meta?.analiActProtHigh;

  const {
    color: analiActProtColor,
    markIn: analiActProtMarkIn,
    markOut: analiActProtMarkOut,
  } = createResultProperties(
    analiActProtResult,
    analiActProtLow,
    analiActProtHigh
  );
  useEffect(() => {
    if (
      analiActProtResult === undefined ||
      analiActProtResult === null ||
      analiActProtResult === 0 ||
      analiActProtResult === ""
    ) {
      let errorMessage = "No existen datos de Actividad de Protrombina";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiActProtResult]);

  // INR
  const analiInrResult = analiticas.meta?.analiInrResult;
  const analiInrLow = (analiticas.meta?.analiInrLow === "") ? analiticaCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_179?.limits2.L.toFixed(2) : analiticas.meta?.analiInrLow;
  const analiInrHigh = (analiticas.meta?.analiInrHigh === "") ? analiticaCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_179?.limits2.H.toFixed(2) : analiticas.meta?.analiInrHigh;

  const {
    color: analiInrColor,
    markIn: analiInrMarkIn,
    markOut: analiInrMarkOut,
  } = createResultProperties(analiInrResult, analiInrLow, analiInrHigh);
  useEffect(() => {
    if (
      analiInrResult === undefined ||
      analiInrResult === null ||
      analiInrResult === 0 ||
      analiInrResult === ""
    ) {
      let errorMessage = "No existen datos de INR";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiInrResult]);

  // Glucosa, Suero/Pl
  const analiGlucResult = analiticas.meta?.analiGlucResult;
  const analiGlucLow = (analiticas.meta?.analiGlucLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_384"]?.limits2.L.toFixed(2) : analiticas.meta?.analiGlucLow;
  const analiGlucHigh = (analiticas.meta?.analiGlucHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_384"]?.limits2.H.toFixed(2) : analiticas.meta?.analiGlucHigh;

  const {
    color: analiGlucColor,
    markIn: analiGlucMarkIn,
    markOut: analiGlucMarkOut,
  } = createResultProperties(analiGlucResult, analiGlucLow, analiGlucHigh);
  useEffect(() => {
    if (
      analiGlucResult === undefined ||
      analiGlucResult === null ||
      analiGlucResult === 0 ||
      analiGlucResult === ""
    ) {
      let errorMessage = "No existen datos de Glucosa";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiGlucResult]);

  // Urea, Suero/Pl
  const analiUreaResult = analiticas.meta?.analiUreaResult;
  const analiUreaLow = (analiticas.meta?.analiUreaLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_436"]?.limits2.L.toFixed(2) : analiticas.meta?.analiUreaLow;
  const analiUreaHigh = (analiticas.meta?.analiUreaHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_436"]?.limits2.H.toFixed(2) : analiticas.meta?.analiUreaHigh;
  const {
    color: analiUreaColor,
    markIn: analiUreaMarkIn,
    markOut: analiUreaMarkOut,
  } = createResultProperties(analiUreaResult, analiUreaLow, analiUreaHigh);

  useEffect(() => {
    if (
      analiUreaResult === undefined ||
      analiUreaResult === null ||
      analiUreaResult === 0 ||
      analiUreaResult === ""
    ) {
      let errorMessage = "No existen datos de Urea";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiUreaResult]);

  // Creatinina, Suero/Pl
  const analiCreatResult = analiticas.meta?.analiCreatResult;
  const analiCreatLow = (analiticas.meta?.analiCreatLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_437"]?.limits2.L.toFixed(2) : analiticas.meta?.analiCreatLow;
  const analiCreatHigh = (analiticas.meta?.analiCreatHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_437"]?.limits2.H.toFixed(2) : analiticas.meta?.analiCreatHigh;

  const {
    color: analiCreatColor,
    markIn: analiCreatMarkIn,
    markOut: analiCreatMarkOut,
  } = createResultProperties(analiCreatResult, analiCreatLow, analiCreatHigh);
  useEffect(() => {
    if (
      analiCreatResult === undefined ||
      analiCreatResult === null ||
      analiCreatResult === 0 ||
      analiCreatResult === ""
    ) {
      let errorMessage = "No existen datos de Creatinina";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiCreatResult]);

  // Filtrado Glomerular CKD-EPI
  const analiGlomResult = analiticas.meta?.analiGlomResult;
  const analiGlomLow = (analiticas.meta?.analiGlomLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_118276"]?.limits2.L.toFixed(2) : analiticas.meta?.analiGlomLow;
  const analiGlomHigh = (analiticas.meta?.analiGlomHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_118276"]?.limits2.H.toFixed(2) : analiticas.meta?.analiGlomHigh;

  const {
    color: analiGlomColor,
    markIn: analiGlomMarkIn,
    markOut: analiGlomMarkOut,
  } = createResultProperties(analiGlomResult, analiGlomLow, analiGlomHigh);
  useEffect(() => {
    if (
      analiGlomResult === undefined ||
      analiGlomResult === null ||
      analiGlomResult === 0 ||
      analiGlomResult === ""
    ) {
      let errorMessage = "No existen datos de Filtrado Glomerular";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiGlomResult]);

  // Aspartato Amino Transferasa (AST/GOT), Suero/Pl
  const analiAsparResult = analiticas.meta?.analiAsparResult;
  const analiAsparLow = (analiticas.meta?.analiAsparLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_498"]?.limits2.L.toFixed(2) : analiticas.meta?.analiAsparLow;
  const analiAsparHigh = (analiticas.meta?.analiAsparHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_498"]?.limits2.H.toFixed(2) : analiticas.meta?.analiAsparHigh;

  const {
    color: analiAsparColor,
    markIn: analiAsparMarkIn,
    markOut: analiAsparMarkOut,
  } = createResultProperties(analiAsparResult, analiAsparLow, analiAsparHigh);
  useEffect(() => {
    if (
      analiAsparResult === undefined ||
      analiAsparResult === null ||
      analiAsparResult === 0 ||
      analiAsparResult === ""
    ) {
      let errorMessage = "No existen datos de Aspartato Amino Transferasa";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiAsparResult]);

  // Alanina Amino Transferasa (ALT/GPT), Suero/Pl
  const analiAlanResult = analiticas.meta?.analiAlanResult;
  const analiAlanLow = (analiticas.meta?.analiAlanLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_499"]?.limits2.L.toFixed(2) : analiticas.meta?.analiAlanLow;
  const analiAlanHigh = (analiticas.meta?.analiAlanHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_499"]?.limits2.H.toFixed(2) : analiticas.meta?.analiAlanHigh;

  const {
    color: analiAlanColor,
    markIn: analiAlanMarkIn,
    markOut: analiAlanMarkOut,
  } = createResultProperties(analiAlanResult, analiAlanLow, analiAlanHigh);
  useEffect(() => {
    if (
      analiAlanResult === undefined ||
      analiAlanResult === null ||
      analiAlanResult === 0 ||
      analiAlanResult === ""
    ) {
      let errorMessage = "No existen datos de Alanina Amino Transferasa";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiAlanResult]);

  // Gamma Glutamil Transferasa (GGT), Suero/Pl
  const analiGammResult = analiticas.meta?.analiGammResult;
  const analiGammLow = (analiticas.meta?.analiGammLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_500"]?.limits2.L.toFixed(2) : analiticas.meta?.analiGammLow;
  const analiGammHigh = (analiticas.meta?.analiGammHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_500"]?.limits2.H.toFixed(2) : analiticas.meta?.analiGammHigh;

  const {
    color: analiGammColor,
    markIn: analiGammMarkIn,
    markOut: analiGammMarkOut,
  } = createResultProperties(analiGammResult, analiGammLow, analiGammHigh);
  useEffect(() => {
    if (
      analiGammResult === undefined ||
      analiGammResult === null ||
      analiGammResult === 0 ||
      analiGammResult === ""
    ) {
      let errorMessage = "No existen datos de Gamma Glutamil Transferasa";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiGammResult]);

  // Fosfatasa Alcalina (FA), Suero/Pl
  const analiFosfResult = analiticas.meta?.analiFosfResult;
  const analiFosfLow = (analiticas.meta?.analiFosfLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_501"]?.limits2.L.toFixed(2) : analiticas.meta?.analiFosfLow;
  const analiFosfHigh = (analiticas.meta?.analiFosfHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_501"]?.limits2.H.toFixed(2) : analiticas.meta?.analiFosfHigh;

  const {
    color: analiFosfColor,
    markIn: analiFosfMarkIn,
    markOut: analiFosfMarkOut,
  } = createResultProperties(analiFosfResult, analiFosfLow, analiFosfHigh);
  useEffect(() => {
    if (
      analiFosfResult === undefined ||
      analiFosfResult === null ||
      analiFosfResult === 0 ||
      analiFosfResult === ""
    ) {
      let errorMessage = "No existen datos de Fosfatasa Alcalina";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiFosfResult]);

  // Bilirrubina total, Suero/Pl
  const analiBiliResult = analiticas.meta?.analiBiliResult;
  const analiBiliLow = (analiticas.meta?.analiBiliLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_549"]?.limits2.L.toFixed(2) : analiticas.meta?.analiBiliLow;
  const analiBiliHigh = (analiticas.meta?.analiBiliHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_549"]?.limits2.H.toFixed(2) : analiticas.meta?.analiBiliHigh;

  const {
    color: analiBiliColor,
    markIn: analiBiliMarkIn,
    markOut: analiBiliMarkOut,
  } = createResultProperties(analiBiliResult, analiBiliLow, analiBiliHigh);
  useEffect(() => {
    if (
      analiBiliResult === undefined ||
      analiBiliResult === null ||
      analiBiliResult === 0 ||
      analiBiliResult === ""
    ) {
      let errorMessage = "No existen datos de Bilirrubina";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiBiliResult]);

  // Colesterol, Suero/Pl
  const analiColestResult = analiticas.meta?.analiColestResult;
  const analiColestLow = (analiticas.meta?.analiColestLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_556"]?.limits2.L.toFixed(2) : analiticas.meta?.analiColestLow;
  const analiColestHigh = (analiticas.meta?.analiColestHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_556"]?.limits2.H.toFixed(2) : analiticas.meta?.analiColestHigh;

  const {
    color: analiColestColor,
    markIn: analiColestMarkIn,
    markOut: analiColestMarkOut,
  } = createResultProperties(
    analiColestResult,
    analiColestLow,
    analiColestHigh
  );
  useEffect(() => {
    if (
      analiColestResult === undefined ||
      analiColestResult === null ||
      analiColestResult === 0 ||
      analiColestResult === ""
    ) {
      let errorMessage = "No existen datos de Colesterol";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiColestResult]);

  // Colesterol HDL, Suero/Pl
  const analiColestHdlResult = analiticas.meta?.analiColestHdlResult;
  const analiColestHdlLow = (analiticas.meta?.analiColestHdlLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_557"]?.limits2.L.toFixed(2) : analiticas.meta?.analiColestHdlLow;
  const analiColestHdlHigh = (analiticas.meta?.analiColestHdlHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_557"]?.limits2.H.toFixed(2) : analiticas.meta?.analiColestHdlHigh;

  const {
    color: analiColestHdlColor,
    markIn: analiColestHdlMarkIn,
    markOut: analiColestHdlMarkOut,
  } = createResultProperties(
    analiColestHdlResult,
    analiColestHdlLow,
    analiColestHdlHigh
  );
  useEffect(() => {
    if (
      analiColestHdlResult === undefined ||
      analiColestHdlResult === null ||
      analiColestHdlResult === 0 ||
      analiColestHdlResult === ""
    ) {
      let errorMessage = "No existen datos de Colesterol HDL";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiColestHdlResult]);

  // Colesterol LDL, Suero/Pl
  const analiColestLdlResult = analiticas.meta?.analiColestLdlResult;
  const analiColestLdlLow = (analiticas.meta?.analiColestLdlLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_574"]?.limits2.L.toFixed(2) : analiticas.meta?.analiColestLdlLow;
  const analiColestLdlHigh = (analiticas.meta?.analiColestLdlHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_574"]?.limits2.H.toFixed(2) : analiticas.meta?.analiColestLdlHigh;

  const {
    color: analiColestLdlColor,
    markIn: analiColestLdlMarkIn,
    markOut: analiColestLdlMarkOut,
  } = createResultProperties(
    analiColestLdlResult,
    analiColestLdlLow,
    analiColestLdlHigh
  );
  useEffect(() => {
    if (
      analiColestLdlResult === undefined ||
      analiColestLdlResult === null ||
      analiColestLdlResult === 0 ||
      analiColestLdlResult === ""
    ) {
      let errorMessage = "No existen datos de Colesterol LDL";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiColestLdlResult]);

  // Triglicéridos, Suero/Pl
  const analiTriglResult = analiticas.meta?.analiTriglResult;
  const analiTriglLow = (analiticas.meta?.analiTriglLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_564"]?.limits2.L.toFixed(2) : analiticas.meta?.analiTriglLow;
  const analiTriglHigh = (analiticas.meta?.analiTriglHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_564"]?.limits2.H.toFixed(2) : analiticas.meta?.analiTriglHigh;

  const {
    color: analiTriglColor,
    markIn: analiTriglMarkIn,
    markOut: analiTriglMarkOut,
  } = createResultProperties(analiTriglResult, analiTriglLow, analiTriglHigh);
  useEffect(() => {
    if (
      analiTriglResult === undefined ||
      analiTriglResult === null ||
      analiTriglResult === 0 ||
      analiTriglResult === ""
    ) {
      let errorMessage = "No existen datos de Triglicéridos";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiTriglResult]);

  // Calcio, Suero/Pl
  const analiCalcResult = analiticas.meta?.analiCalcResult;
  const analiCalcLow = (analiticas.meta?.analiCalcLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_467"]?.limits2.L.toFixed(2) : analiticas.meta?.analiCalcLow;
  const analiCalcHigh = (analiticas.meta?.analiCalcHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_467"]?.limits2.H.toFixed(2) : analiticas.meta?.analiCalcHigh;

  const {
    color: analiCalcColor,
    markIn: analiCalcMarkIn,
    markOut: analiCalcMarkOut,
  } = createResultProperties(analiCalcResult, analiCalcLow, analiCalcHigh);
  useEffect(() => {
    if (
      analiCalcResult === undefined ||
      analiCalcResult === null ||
      analiCalcResult === 0 ||
      analiCalcResult === ""
    ) {
      let errorMessage = "No existen datos de Calcio";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiCalcResult]);

  // Hierro, Suero/Pl
  const analiHierrResult = analiticas.meta?.analiHierrResult;
  const analiHierrLow = (analiticas.meta?.analiHierrLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_596"]?.limits2.L.toFixed(2) : analiticas.meta?.analiHierrLow;
  const analiHierrHigh = (analiticas.meta?.analiHierrHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_596"]?.limits2.H.toFixed(2) : analiticas.meta?.analiHierrHigh;

  const {
    color: analiHierrColor,
    markIn: analiHierrMarkIn,
    markOut: analiHierrMarkOut,
  } = createResultProperties(analiHierrResult, analiHierrLow, analiHierrHigh);
  useEffect(() => {
    if (
      analiHierrResult === undefined ||
      analiHierrResult === null ||
      analiHierrResult === 0 ||
      analiHierrResult === ""
    ) {
      let errorMessage = "No existen datos de Hierro";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiHierrResult]);

  // Sodio, Suero/Pl
  const analiSodResult = analiticas.meta?.analiSodResult;
  const analiSodLow = (analiticas.meta?.analiSodLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_613"]?.limits2.L.toFixed(2) : analiticas.meta?.analiSodLow;
  const analiSodHigh = (analiticas.meta?.analiSodHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_613"]?.limits2.H.toFixed(2) : analiticas.meta?.analiSodHigh;

  const {
    color: analiSodColor,
    markIn: analiSodMarkIn,
    markOut: analiSodMarkOut,
  } = createResultProperties(analiSodResult, analiSodLow, analiSodHigh);
  useEffect(() => {
    if (
      analiSodResult === undefined ||
      analiSodResult === null ||
      analiSodResult === 0 ||
      analiSodResult === ""
    ) {
      let errorMessage = "No existen datos de Sodio";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiSodResult]);

  // Potasio, Suero/Pl
  const analiPotasResult = analiticas.meta?.analiPotasResult;
  const analiPotasLow = (analiticas.meta?.analiPotasLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_614"]?.limits2.L.toFixed(2) : analiticas.meta?.analiPotasLow;
  const analiPotasHigh = (analiticas.meta?.analiPotasHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_614"]?.limits2.H.toFixed(2) : analiticas.meta?.analiPotasHigh;

  const {
    color: analiPotasColor,
    markIn: analiPotasMarkIn,
    markOut: analiPotasMarkOut,
  } = createResultProperties(analiPotasResult, analiPotasLow, analiPotasHigh);
  useEffect(() => {
    if (
      analiPotasResult === undefined ||
      analiPotasResult === null ||
      analiPotasResult === 0 ||
      analiPotasResult === ""
    ) {
      let errorMessage = "No existen datos de Potasio";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiPotasResult]);

  // Vitamina B12, Suero/Pl
  const analiVitbResult = analiticas.meta?.analiVitbResult;
  const analiVitbLow = (analiticas.meta?.analiVitbLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_894"]?.limits2.L.toFixed(2) : analiticas.meta?.analiVitbLow;
  const analiVitbHigh = (analiticas.meta?.analiVitbHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_894"]?.limits2.H.toFixed(2) : analiticas.meta?.analiVitbHigh;

  const {
    color: analiVitbColor,
    markIn: analiVitbMarkIn,
    markOut: analiVitbMarkOut,
  } = createResultProperties(analiVitbResult, analiVitbLow, analiVitbHigh);
  useEffect(() => {
    if (
      analiVitbResult === undefined ||
      analiVitbResult === null ||
      analiVitbResult === 0 ||
      analiVitbResult === ""
    ) {
      let errorMessage = "No existen datos de Vitamina B12";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiVitbResult]);

  // 25-OH Vitamina D
  const analiVitohResult = analiticas.meta?.analiVitohResult;
  const analiVitohLow = (analiticas.meta?.analiVitohLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_902"]?.limits2.L.toFixed(2) : analiticas.meta?.analiVitohLow;
  const analiVitohHigh = (analiticas.meta?.analiVitohHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_902"]?.limits2.H.toFixed(2) : analiticas.meta?.analiVitohHigh;

  const {
    color: analiVitohColor,
    markIn: analiVitohMarkIn,
    markOut: analiVitohMarkOut,
  } = createResultProperties(analiVitohResult, analiVitohLow, analiVitohHigh);
  useEffect(() => {
    if (
      analiVitohResult === undefined ||
      analiVitohResult === null ||
      analiVitohResult === 0 ||
      analiVitohResult === ""
    ) {
      let errorMessage = "No existen datos de 25-OH Vitamina D";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiVitohResult]);

  // Ácido Fólico Folato, Suero/Pl
  const analiAcidfolResult = analiticas.meta?.analiAcidfolResult;
  const analiAcidfolLow = (analiticas.meta?.analiAcidfolLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_890"]?.limits2.L.toFixed(2) : analiticas.meta?.analiAcidfolLow;
  const analiAcidfolHigh = (analiticas.meta?.analiAcidfolHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_890"]?.limits2.H.toFixed(2) : analiticas.meta?.analiAcidfolHigh;

  const {
    color: analiAcidfolColor,
    markIn: analiAcidfolMarkIn,
    markOut: analiAcidfolMarkOut,
  } = createResultProperties(
    analiAcidfolResult,
    analiAcidfolLow,
    analiAcidfolHigh
  );
  useEffect(() => {
    if (
      analiAcidfolResult === undefined ||
      analiAcidfolResult === null ||
      analiAcidfolResult === 0 ||
      analiAcidfolResult === ""
    ) {
      let errorMessage = "No existen datos de Ácido Fólico Folato";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiAcidfolResult]);

  // Magnesio, Suero/Pl
  const analiMagnResult = analiticas.meta?.analiMagnResult;
  const analiMagnLow = (analiticas.meta?.analiMagnLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_1284"]?.limits2.L.toFixed(2) : analiticas.meta?.analiMagnLow;
  const analiMagnHigh = (analiticas.meta?.analiMagnHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_1284"]?.limits2.H.toFixed(2) : analiticas.meta?.analiMagnHigh;

  const {
    color: analiMagnColor,
    markIn: analiMagnMarkIn,
    markOut: analiMagnMarkOut,
  } = createResultProperties(analiMagnResult, analiMagnLow, analiMagnHigh);
  useEffect(() => {
    if (
      analiMagnResult === undefined ||
      analiMagnResult === null ||
      analiMagnResult === 0 ||
      analiMagnResult === ""
    ) {
      let errorMessage = "No existen datos de Magnesio";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiMagnResult]);

  // Ferritina, Suero/Pl
  const analiFerriResult = analiticas.meta?.analiFerriResult;
  const analiFerriLow = (analiticas.meta?.analiFerriLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_1042"]?.limits2.L.toFixed(2) : analiticas.meta?.analiFerriLow;
  const analiFerriHigh = (analiticas.meta?.analiFerriHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_1042"]?.limits2.H.toFixed(2) : analiticas.meta?.analiFerriHigh;

  const {
    color: analiFerriColor,
    markIn: analiFerriMarkIn,
    markOut: analiFerriMarkOut,
  } = createResultProperties(analiFerriResult, analiFerriLow, analiFerriHigh);
  useEffect(() => {
    if (
      analiFerriResult === undefined ||
      analiFerriResult === null ||
      analiFerriResult === 0 ||
      analiFerriResult === ""
    ) {
      let errorMessage = "No existen datos de Ferritina";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiFerriResult]);

  // Proteína C Reactiva (PCR), Suero/Pl
  const analiProtcResult = analiticas.meta?.analiProtcResult;
  const analiProtcLow = (analiticas.meta?.analiProtcLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_764"]?.limits2.L.toFixed(2) : analiticas.meta?.analiProtcLow;
  const analiProtcHigh = (analiticas.meta?.analiProtcHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_764"]?.limits2.H.toFixed(2) : analiticas.meta?.analiProtcHigh;

  const {
    color: analiProtcColor,
    markIn: analiProtcMarkIn,
    markOut: analiProtcMarkOut,
  } = createResultProperties(analiProtcResult, analiProtcLow, analiProtcHigh);
  useEffect(() => {
    if (
      analiProtcResult === undefined ||
      analiProtcResult === null ||
      analiProtcResult === 0 ||
      analiProtcResult === ""
    ) {
      let errorMessage = "No existen datos de Proteína C Reactiva";
      console.log(errorMessage);
      setWarningMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }, [analiticas, analiProtcResult]);

  // Cortisol
  const analiCortiResult = analiticas.meta?.analiCortiResult;
  const analiCortiLow = (analiticas.meta?.analiCortiLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_123"]?.limits2.L.toFixed(2) : analiticas.meta?.analiCortiLow;
  const analiCortiHigh = (analiticas.meta?.analiCortiHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_123"]?.limits2.H.toFixed(2) : analiticas.meta?.analiCortiHigh;

  const {
    color: analiCortiColor,
    markIn: analiCortiMarkIn,
    markOut: analiCortiMarkOut,
  } = createResultProperties(analiCortiResult, analiCortiLow, analiCortiHigh);
  useEffect(() => {
    if (
      analiCortiResult === undefined ||
      analiCortiResult === null ||
      analiCortiResult === 0 ||
      analiCortiResult === ""
    ) {
      let errorMessage = "No existen datos de Cortisol";
      console.log(errorMessage);
      setWarningSecondMessages((prevMessages) => [
        ...prevMessages,
        errorMessage,
      ]);
    }
  }, [analiticas, analiCortiResult]);

  // DHEA
  const analiDheaResult = analiticas.meta?.analiDheaResult;
  const analiDheaLow = (analiticas.meta?.analiDheaLow === "") ? analiticaCompleta?.results?.GEN?.CERBA?.["TK:A_1013"]?.limits2.L.toFixed(2) : analiticas.meta?.analiDheaLow;
  const analiDheaHigh = (analiticas.meta?.analiDheaHigh === "") ? analiticaCompleta?.results?.GEN?.CERBA?.["TK:A_1013"]?.limits2.H.toFixed(2) : analiticas.meta?.analiDheaHigh;

  const {
    color: analiDheaColor,
    markIn: analiDheaMarkIn,
    markOut: analiDheaMarkOut,
  } = createResultProperties(analiDheaResult, analiDheaLow, analiDheaHigh);
  useEffect(() => {
    if (
      analiDheaResult === undefined ||
      analiDheaResult === null ||
      analiDheaResult === 0 ||
      analiDheaResult === ""
    ) {
      let errorMessage = "No existen datos de DHEA";
      console.log(errorMessage);
      setWarningSecondMessages((prevMessages) => [
        ...prevMessages,
        errorMessage,
      ]);
    }
  }, [analiticas, analiDheaResult]);

  // DHEA-S
  const analiDheaSResult = analiticas.meta?.analiDheaSResult;
  const analiDheaSLow = (analiticas.meta?.analiDheaSLow === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_1010"]?.limits2.L.toFixed(2) : analiticas.meta?.analiDheaSLow;
  const analiDheaSHigh = (analiticas.meta?.analiDheaSHigh === "") ? analiticaCompleta?.results?.GEN?.BIOQ?.["TK:A_1010"]?.limits2.H.toFixed(2) : analiticas.meta?.analiDheaSHigh;

  const {
    color: analiDheaSColor,
    markIn: analiDheaSMarkIn,
    markOut: analiDheaSMarkOut,
  } = createResultProperties(analiDheaSResult, analiDheaSLow, analiDheaSHigh);
  useEffect(() => {
    if (
      analiDheaSResult === undefined ||
      analiDheaSResult === null ||
      analiDheaSResult === 0 ||
      analiDheaSResult === ""
    ) {
      let errorMessage = "No existen datos de DHEA-S";
      console.log(errorMessage);
      setWarningSecondMessages((prevMessages) => [
        ...prevMessages,
        errorMessage,
      ]);
    }
  }, [analiticas, analiDheaSResult]);

  const analiDate = new Date(analiticas.date);
  const diffDate = Math.abs(new Date() - analiDate) / 36e5;

  let { tratamientoId } = useParams();

  // useEffect(() => {
  //   if (
  //     analiCortiResult != null ||
  //     analiDheaResult != null ||
  //     analiDheaSResult != null
  //   ) {
  //     setAnaliticaIsSecond(true);
  //   } else {
  //     setAnaliticaIsSecond(false);
  //   }
  // }, [analiticaCompleta]);

  const [isDownloading, setIsDownloading] = useState(false);

  // const handleDownload = () => {
  //   setIsDownloading(true);
  //   const fileName = analiFileLink.split("/").pop();
  //   fetch(analiFileLink)
  //     .then(response => response.blob())
  //     .then(blob => {
  //       console.log(blob);
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = fileName;
  //       a.click();
  //       window.URL.revokeObjectURL(url);
  //       setIsDownloading(false);
  //     });
  // };

  const handleDownload = async () => {
    setIsDownloading(true);
    const archivoUrlParam = encodeURIComponent(analiFileLink);
    const fileName = analiFileLink.split("/").pop();
    try {
      const data = await getArchivo(archivoUrlParam);
      console.log(data);
      const blob = new Blob([data], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      setIsDownloading(false);
    } catch (error) {
      console.error(error);
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div id="content">
        {analiticas.length === 0 ? (
          <div>Cargando...</div>
        ) : errorLoadMessage ? (
          <p>{errorLoadMessage}</p>
        ) : (

          <>
          {isNotJson && (
                <>
                  <div className="anali-btn-dwnld btn-dwnld">
                    <button className="button is-link" onClick={handleDownload}>{isDownloading ? 'Descargando...' : 'Descargar documento'}</button>
                  </div>
                </>
              )}
          <form id="formUpdatelement">
            <fieldset id="disabledContainer" disabled="disabled">

              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="analiFechaAnali">Fecha Analítica</label>
                  <div className="control">
                    <input
                      className="input"
                      id="analiFechaAnali"
                      required
                      type="date"
                      readOnly
                      value={analiFechaAnali}
                    />
                  </div>
                </div>
              </div>
              <div className="analitic-form">
                

                {(analiHematiesResult ||
                  analiHemoglobResult ||
                  analiHematcrResult ||
                  analiVcmResult ||
                  analiHcmResult ||
                  analiChcmResult ||
                  analiIdhResult ||
                  analiLeucoResult ||
                  analiNeutrResult ||
                  analiLinfoResult ||
                  analiMonocResult ||
                  analiEosinResult ||
                  analiBasofResult ||
                  analiPlaqResult ||
                  analiPctResult ||
                  analiVpmResult ||
                  analiIdpResult) && (
                  <>
                    <h3>Hematología</h3>
                    <div className="three-col-analitic">
                      {analiHematiesResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hematies</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHematiesColor}`}>
                              {analiHematiesResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>6</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiHematiesMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{
                                    left: `${analiHematiesMarkIn}%`,
                                  }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHematiesLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHematiesHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiHemoglobResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hemoglobina</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHemoglobColor}`}>
                              {analiHemoglobResult}
                            </p>
                            <p className="anali-units">g/dL</p>
                            <div
                              className={`anali-bar-full ${analiHemoglobMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{
                                    left: `${analiHemoglobMarkIn}%`,
                                  }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHemoglobLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHemoglobHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiHematcrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hematocrito</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHematcrColor}`}>
                              {analiHematcrResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiHematcrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHematcrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHematcrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHematcrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiVcmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">VCM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVcmColor}`}>
                              {analiVcmResult}
                            </p>
                            <p className="anali-units">fL</p>
                            <div
                              className={`anali-bar-full ${analiVcmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVcmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVcmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVcmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiHcmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">HCM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHcmColor}`}>
                              {analiHcmResult}
                            </p>
                            <p className="anali-units">pg/cél</p>
                            <div
                              className={`anali-bar-full ${analiHcmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHcmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHcmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHcmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiChcmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">CHCM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiChcmColor}`}>
                              {analiChcmResult}
                            </p>
                            <p className="anali-units">g/dL</p>
                            <div
                              className={`anali-bar-full ${analiChcmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiChcmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiChcmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiChcmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiIdhResult ? (
                        <div className="anali-el">
                          <p className="anali-title">IDH</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiIdhColor}`}>
                              {analiIdhResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiIdhMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiIdhMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiIdhLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiIdhHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiLeucoResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Leucocitos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiLeucoColor}`}>
                              {analiLeucoResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiLeucoMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiLeucoMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiLeucoLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiLeucoHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiNeutrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Neutrófilos segmentados</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiNeutrColor}`}>
                              {analiNeutrResult}
                            </p>
                            <p className="anali-units"></p>
                            <div
                              className={`anali-bar-full ${analiNeutrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiNeutrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiNeutrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiNeutrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiLinfoResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Linfocitos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiLinfoColor}`}>
                              {analiLinfoResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiLinfoMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiLinfoMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiLinfoLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiLinfoHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiMonocResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Monocitos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiMonocColor}`}>
                              {analiMonocResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiMonocMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiMonocMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiMonocLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiMonocHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiEosinResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Eosinófilos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiEosinColor}`}>
                              {analiEosinResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiEosinMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiEosinMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiEosinLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiEosinHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiBasofResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Basófilos</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiBasofColor}`}>
                              {analiBasofResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiBasofMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiBasofMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiBasofLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiBasofHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiPlaqResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Plaquetas</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiPlaqColor}`}>
                              {analiPlaqResult}
                            </p>
                            <p className="anali-units">
                              x10<sup>3</sup>/μL
                            </p>
                            <div
                              className={`anali-bar-full ${analiPlaqMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiPlaqMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiPlaqLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiPlaqHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiPctResult ? (
                        <div className="anali-el">
                          <p className="anali-title">PCT</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiPctColor}`}>
                              {analiPctResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiPctMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiPctMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiPctLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiPctHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiVpmResult ? (
                        <div className="anali-el">
                          <p className="anali-title">VPM</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVpmColor}`}>
                              {analiVpmResult}
                            </p>
                            <p className="anali-units">fL</p>
                            <div
                              className={`anali-bar-full ${analiVpmMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVpmMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVpmLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVpmHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiIdpResult ? (
                        <div className="anali-el">
                          <p className="anali-title">IDP</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiIdpColor}`}>
                              {analiIdpResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiIdpMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiIdpMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiIdpLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiIdpHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {(analiTieProtResult ||
                  analiActProtResult ||
                  analiInrResult) && (
                  <>
                    <h3>Coagulación</h3>
                    <div className="three-col-analitic">
                      {analiTieProtResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Tiempo de Protrombina (seg)
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiTieProtColor}`}>
                              {analiTieProtResult}
                            </p>
                            <p className="anali-units">seg</p>
                            <div
                              className={`anali-bar-full ${analiTieProtMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiTieProtMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiTieProtLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiTieProtHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {analiActProtResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Actividad de Protrombina (%)
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiActProtColor}`}>
                              {analiActProtResult}
                            </p>
                            <p className="anali-units">%</p>
                            <div
                              className={`anali-bar-full ${analiActProtMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiActProtMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiActProtLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiActProtHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiInrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">INR</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiInrColor}`}>
                              {analiInrResult}
                            </p>
                            <p className="anali-units"></p>
                            <div
                              className={`anali-bar-full ${analiInrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiInrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiInrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiInrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {(analiGlucResult ||
                  analiUreaResult ||
                  analiCreatResult ||
                  analiGlomResult ||
                  analiAsparResult ||
                  analiAlanResult ||
                  analiGammResult ||
                  analiFosfResult ||
                  analiBiliResult ||
                  analiColestResult ||
                  analiColestHdlResult ||
                  analiColestLdlResult ||
                  analiTriglResult ||
                  analiCalcResult ||
                  analiHierrResult ||
                  analiSodResult ||
                  analiPotasResult ||
                  analiVitbResult ||
                  analiVitohResult ||
                  analiAcidfolResult ||
                  analiMagnResult) && (
                  <>
                    <h3>Bioquímica</h3>

                    <div className="three-col-analitic">
                      {analiGlucResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Glucosa, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiGlucColor}`}>
                              {analiGlucResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiGlucMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiGlucMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiGlucLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiGlucHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiUreaResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Urea, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiUreaColor}`}>
                              {analiUreaResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiUreaMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiUreaMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiUreaLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiUreaHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiCreatResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Creatinina, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiCreatColor}`}>
                              {analiCreatResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiCreatMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiCreatMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiCreatLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiCreatHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiGlomResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Filtrado Glomerular CKD-EPI
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiGlomColor}`}>
                              {analiGlomResult}
                            </p>
                            <p className="anali-units">mL/min/1,7</p>
                            <div
                              className={`anali-bar-full ${analiGlomMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiGlomMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiGlomLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiGlomHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiAsparResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Aspartato Amino Transferasa (AST/GOT), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiAsparColor}`}>
                              {analiAsparResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiAsparMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiAsparMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiAsparLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiAsparHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiAlanResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Alanina Amino Transferasa (ALT/GPT), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiAlanColor}`}>
                              {analiAlanResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiAlanMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiAlanMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiAlanLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiAlanHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiGammResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Gamma Glutamil Transferasa (GGT), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiGammColor}`}>
                              {analiGammResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiGammMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiGammMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiGammLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiGammHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiFosfResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Fosfatasa Alcalina (FA), Suero/Pl{" "}
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiFosfColor}`}>
                              {analiFosfResult}
                            </p>
                            <p className="anali-units">U/L</p>
                            <div
                              className={`anali-bar-full ${analiFosfMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiFosfMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiFosfLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiFosfHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiBiliResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Bilirrubina total, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiBiliColor}`}>
                              {analiBiliResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiBiliMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiBiliMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiBiliLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiBiliHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiColestResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Colesterol, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiColestColor}`}>
                              {analiColestResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiColestMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiColestMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiColestLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiColestHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiColestHdlResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Colesterol HDL, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p
                              className={`anali-result ${analiColestHdlColor}`}
                            >
                              {analiColestHdlResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiColestHdlMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{
                                    left: `${analiColestHdlMarkIn}%`,
                                  }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiColestHdlLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiColestHdlHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiColestLdlResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Colesterol LDL, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p
                              className={`anali-result ${analiColestLdlColor}`}
                            >
                              {analiColestLdlResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiColestLdlMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{
                                    left: `${analiColestLdlMarkIn}%`,
                                  }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiColestLdlLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiColestLdlHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiTriglResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Triglicéridos, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiTriglColor}`}>
                              {analiTriglResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiTriglMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiTriglMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiTriglLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiTriglHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiCalcResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Calcio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiCalcColor}`}>
                              {analiCalcResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiCalcMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiCalcMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiCalcLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiCalcHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiHierrResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Hierro, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiHierrColor}`}>
                              {analiHierrResult}
                            </p>
                            <p className="anali-units">μg/dL</p>
                            <div
                              className={`anali-bar-full ${analiHierrMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiHierrMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiHierrLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiHierrHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiSodResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Sodio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiSodColor}`}>
                              {analiSodResult}
                            </p>
                            <p className="anali-units">mMol/L</p>
                            <div
                              className={`anali-bar-full ${analiSodMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiSodMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiSodLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiSodHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiPotasResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Potasio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiPotasColor}`}>
                              {analiPotasResult}
                            </p>
                            <p className="anali-units">mMol/L</p>
                            <div
                              className={`anali-bar-full ${analiPotasMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiPotasMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiPotasLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiPotasHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiVitbResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Vitamina B12, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVitbColor}`}>
                              {analiVitbResult}
                            </p>
                            <p className="anali-units">pg/mL</p>
                            <div
                              className={`anali-bar-full ${analiVitbMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVitbMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVitbLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVitbHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiVitohResult ? (
                        <div className="anali-el">
                          <p className="anali-title">25-OH Vitamina D</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiVitohColor}`}>
                              {analiVitohResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiVitohMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiVitohMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiVitohLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiVitohHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiAcidfolResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Acido Folico Folato, Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiAcidfolColor}`}>
                              {analiAcidfolResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiAcidfolMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiAcidfolMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiAcidfolLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiAcidfolHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiMagnResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Magnesio, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiMagnColor}`}>
                              {analiMagnResult}
                            </p>
                            <p className="anali-units">mg/dL</p>
                            <div
                              className={`anali-bar-full ${analiMagnMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiMagnMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiMagnLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiMagnHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {(analiFerriResult || analiProtcResult) && (
                  <>
                    <h3>Proteínas</h3>
                    <div className="three-col-analitic">
                      {analiFerriResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Ferritina, Suero/Pl</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiFerriColor}`}>
                              {analiFerriResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiFerriMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiFerriMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiFerriLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiFerriHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiProtcResult ? (
                        <div className="anali-el">
                          <p className="anali-title">
                            Proteína C Reactiva (PCR), Suero/Pl
                          </p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiProtcColor}`}>
                              {analiProtcResult}
                            </p>
                            <p className="anali-units">mg/L</p>
                            <div
                              className={`anali-bar-full ${analiProtcMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiProtcMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiProtcLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiProtcHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                {(analiCortiResult || analiDheaResult || analiDheaSResult) && (
                  <>
                    <h3>Analítica B</h3>
                    <div className="three-col-analitic">
                      {analiCortiResult ? (
                        <div className="anali-el">
                          <p className="anali-title">Cortisol</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiCortiColor}`}>
                              {analiCortiResult}
                            </p>
                            <p className="anali-units">ng/mL</p>
                            <div
                              className={`anali-bar-full ${analiCortiMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiCortiMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiCortiLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiCortiHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiDheaResult ? (
                        <div className="anali-el">
                          <p className="anali-title">DHEA</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiDheaColor}`}>
                              {analiDheaResult}
                            </p>
                            <p className="anali-units">mg/L</p>
                            <div
                              className={`anali-bar-full ${analiDheaMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiDheaMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiDheaLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiDheaHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {analiDheaSResult ? (
                        <div className="anali-el">
                          <p className="anali-title">DHEA-S</p>
                          <div className="anali-result-container">
                            <p className={`anali-result ${analiDheaSColor}`}>
                              {analiDheaSResult}
                            </p>
                            <p className="anali-units">mg/L</p>
                            <div
                              className={`anali-bar-full ${analiDheaSMarkOut}`}
                            >
                              <div className="anali-bar anali-bar-low"></div>
                              <div className="anali-bar anali-bar-main">
                                <div
                                  className="anali-bar-mark"
                                  style={{ left: `${analiDheaSMarkIn}%` }}
                                ></div>
                              </div>
                              <div className="anali-bar anali-bar-high"></div>
                            </div>
                            <div className="anali-limit-container">
                              <p className="anali-limit anali-limit-low">
                                {analiDheaSLow}
                              </p>
                              <p className="anali-limit anali-limit-high">
                                {analiDheaSHigh}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
              </div>
            </fieldset>
          </form>
          </>
        )}
      </div>
      {!errorLoadMessage && (
        <div id="actions">
          {((diffDate <= 72 && props.userRole.includes("psicologia")) ||
            props.userRole.includes("administrador")) && (
            <Link className="button is-link" to={`edit`}>
              Editar
            </Link>
          )}
          {(props.userRole.includes("administrador") ||
            props.userRole.includes("psicologia")) && (
            <Link
              className="button is-link"
              to={`../${tratamientoId}/analiticas/new`}
            >
              Nuevo
            </Link>
          )}
        </div>
      )}
    </>
  );
}

export default AnaliticasPacienteItem;
